<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<form [formGroup]="emisorLogoFormGroup" #logoFormRef="ngForm" (ngSubmit)="onSubmit($event)">
	<div class="modal-body">
		
		<div class="row mb-3">
			<!-- Preview Logo para Documentos -->
			<div class="col-6">
				<div class="text-center" *ngIf="logoRequest.logoFile || (currentLogoEmisor && currentLogoEmisor.logoFile)">
					<p class="text-muted mb-2"><small><strong>Preview Logo Documentos:</strong></small></p>
					<img [src]="logoRequest.logoFile ? 'data:image/png;base64,' + logoRequest.logoFile : 'data:image/png;base64,' + currentLogoEmisor.logoFile" 
						alt="logo documentos" 
						class="img-thumbnail" 
						style="max-width: 150px; max-height: 150px; object-fit: contain;" />
				</div>
			</div>
			
			<!-- Preview Logo para Login -->
			<div class="col-6">
				<div class="text-center" *ngIf="logoLoginPreview">
					<p class="text-muted mb-2"><small><strong>Preview Logo Login:</strong></small></p>
					<img [src]="logoLoginPreview" alt="logo login preview" class="img-thumbnail" style="max-width: 150px; max-height: 150px; object-fit: contain;" />
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="row">
				<!-- Logo para Documentos -->
				<div class="col-6">
					<div class="form-group position-relative">
						<label class="label-control mb-3"><strong>Logo para Documentos</strong></label>
						<ngx-dropzone class="mx-auto" (change)="onSelect($event)" maxFileSize="2097152" accept="image/jpg,image/jpeg,image/png" multiple="false">
							<ngx-dropzone-label class="px-3">
								<i class="flaticon-upload"></i>
								<p>Arrastra o selecciona un archivo con la imagen del logo a utilizar</p>
								<p><small>Formato: .png o .jpg</small></p>
							</ngx-dropzone-label>
							<ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
								<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
							</ngx-dropzone-preview>
						</ngx-dropzone>
						
						<div *ngIf="logoFormRef.submitted && (emisorLogoFormGroup.get('logoFile').invalid || emisorLogoFormGroup.get('logoFile').dirty)" class="invalid-feedback">
							<div *ngIf="emisorLogoFormGroup.get('logoFile').errors?.required">Campo requerido</div>
						</div>
					</div>
				</div>

        		<!-- Logo para Login -->
				<div class="col-6">
					<div class="form-group position-relative">
						<label class="label-control mb-3"><strong>Logo para Login (Publicitario)</strong></label>
						<ngx-dropzone class="mx-auto" (change)="onSelectLoginLogo($event)" maxFileSize="102400" accept="image/png" multiple="false">
							<ngx-dropzone-label class="px-3">
								<i class="flaticon-upload"></i>
								<p>Opcional: Sube tu propio logo para el login</p>
								<p class="text-muted"><small>Formato PNG, menor a 100 KB</small></p>
							</ngx-dropzone-label>
							<ngx-dropzone-preview *ngFor="let f of filesLogin" [removable]="true" (removed)="onRemoveLoginLogo(f)">
								<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
							</ngx-dropzone-preview>
						</ngx-dropzone>
					</div>
					<div class="form-group position-relative mx-auto mt-4">
						<div class="row">
							<div class="col-12">
								<div class="checkbox-inline">
									<label class="checkbox checkbox-outline">
										<input type="checkbox" formControlName="permisoPublicitario" />
										<span></span>
										Permito que se use este logo con fines publicitarios
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
    		</div>
		</div>
		

		<div class="form-group position-relative mx-auto regla-separadora-top">
			<span class="text-danger offset-sm-2" *ngIf="plantillasPdfDisponibles.length == 0">No tiene plantillas de impresión disponibles para previsualizar un logo</span>
			<div class="row">
				<label for="" class="col-2 label-control">Tipo documento</label>
				<div class="col-6">
					<ng-select [items]="plantillasPdfDisponibles" formControlName="plantillaImpresionPreview" [clearable]="false" bindLabel="nombreTipoDte"></ng-select>
				</div>
				<div class="col-4">
					<button [disabled]="!plantillasPdfDisponibles || plantillasPdfDisponibles.length == 0" type="button" class="btn btn-warning" (click)="previewOfLogo()">Previsualizar en documento</button>
					<br />
					<small>Esto es solo una previsualización.</small>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<p style="margin-right: auto;">Este logo se vera reflejado en la impresión de sus documentos</p>
		<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
			<i class="la la-paper-plane-o d-lg-none"></i>
			<span class="d-none d-lg-block">Guardar</span>
		</button>
		<button type="button" class="btn btn-secondary ml-3" (click)="closeLogoModal()">
			<span class="d-none d-lg-block">Cerrar</span>
		</button>
	</div>
</form>
